import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Button, Image, Flex } from 'antd';
import { ArrowLeftOutlined, CalendarOutlined } from '@ant-design/icons';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import NewsContent from '../../components/News/NewsContent';
import IntlMessage from '../../components/IntlMessage/IntlMessage';
import { newsData } from '../../data/newsData';
import styles from '../../components/News/news.module.css';

const { Title, Paragraph } = Typography;

const NewsDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const news = newsData.find(item => item.id === parseInt(id));

  if (!news) {
    return (
      <div className={styles.newsPage}>
        <Header />
        <div style={{ padding: '60px 24px', paddingTop: '120px', textAlign: 'center' }}>
          <Title level={2}>
            <IntlMessage id={'newsDetail.notFound.title'}/>
          </Title>
          <Paragraph>
            <IntlMessage id={'newsDetail.notFound.description'}/>
          </Paragraph>
          <Button type="primary" onClick={() => navigate('/news')}>
            <IntlMessage id={'newsDetail.notFound.backButton'}/>
          </Button>
        </div>
        <Footer />
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className={styles.newsPage}>
      <Header />
      
      <div className={styles.newsDetailContainer}>
        <div className={styles.newsDetailContent}>
          <Button 
            icon={<ArrowLeftOutlined />}
            onClick={handleBackClick}
            className={styles.backButton}
          >
            <IntlMessage id={'newsDetail.backButton'}/>
          </Button>

          {news.headerImage && (
            <div className={styles.newsDetailHeader}>
              <Image
                src={news.headerImage}
                alt={news.title}
                className={styles.newsDetailHeaderImage}
                fallback="/images/placeholder-news.svg"
              />
            </div>
          )}

          <div className={styles.newsDetailBody}>
            <div className={styles.newsDetailMeta}>
              <CalendarOutlined className={styles.dateIcon} />
              <span className={styles.dateText}>{formatDate(news.date)}</span>
            </div>

            <Title level={1} className={styles.newsDetailTitle}>
              {news.title}
            </Title>

            <Paragraph className={styles.newsDetailExcerpt}>
              {news.excerpt}
            </Paragraph>

            <NewsContent content={news.content} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NewsDetailPage; 